<div class="item-container d-flex flex-column">
	<div class="item-header">
		<h6 class="text-center">Hire Recruiter</h6>
		<div class="edit-icons" (click)="onCancel()">
			<i class="material-icons">close</i>
		</div>
	</div>
	<div class="item-content flex-grow-1">		
		<form action="" [formGroup]="dialogForm" class="h-100 d-flex flex-column justify-content-between">
			<div>
				<label for="" class="mt-3 mt-lg-5 mb-2 text-black">Search & Select Recruiter</label>
				<ng-multiselect-dropdown formControlName="recruiter" [settings]="dropdownSettings" [data]="getEmpData" >
				</ng-multiselect-dropdown>
				<mat-error *ngIf="isControlHasError('recruiter','required')"> Please select recruiter to send invitation</mat-error>
			</div>		
			<div class="row flex-1">
				<div class="col-md-8 m-auto mt-xl-2">
					<button mat-raised-button color="primary"  class="auth-form-btn mt-3 mt-lg-4 "(click)="onSubmit()"  type="submit">
						{{"Send Invitation"|translate}} </button>
				</div>
			 </div>
		</form>
	</div>
</div>
<app-loading-spinner></app-loading-spinner>